import { useContext } from 'react';
import {
  DetailContext,
  abortableFetch,
  useEventCallback,
} from '@eas/common-web';
import { ChallengedAct, EsFile } from '@models';
import { EsFileState, EvidenceApiUrl } from '@enums';

export function useAddChallengedActDialog() {
  const { source } = useContext(DetailContext);

  const callApi = useEventCallback(
    (formData: ChallengedAct, esFile?: EsFile) => {
      const detailEsFile = esFile ?? source.data;
      const updateClosed = detailEsFile?.state === EsFileState.CLOSED;

      return abortableFetch(
        `${EvidenceApiUrl.ES_FILES}/challenged-act${
          updateClosed ? '/update-closed' : ''
        }`,
        {
          method: 'POST',
          headers: new Headers({
            'Content-Type': 'application/json',
          }),
          body: JSON.stringify({
            ...formData,
            esFile: { id: detailEsFile.id, agenda: detailEsFile.agenda },
          }),
        }
      );
    }
  );

  return {
    callApi,
  };
}
